/* global SubmitEvent */
import "./include-string-startswith-endswith-polyfill.js";
import fieldInputBackup from './fieldInputBackupMainInclude.js';
import {confirmationBoxDialog} from "./include-dialogs.js";

export default function() {
    //Es gibt zwar schon einen HTML-Standard dafür, dass ein SubmitEvent eine Property "submitter" hat, die auf den Submit-Button verweist, der das
    //Submit-Event ausgelöst hat, aber der Browser-Support ist noch nicht ideal: Nicht nur kann der IE das nicht, stand April 2021 auch der Safari nicht.
    //Daher wird hier noch ein extra Eventhandler für die Submit-Buttons zum Heftschließen gebaut, der den Click registriert und den gedrückten 
    //Submit-Button beim Form hinterlegt. Wird nur benötigt, wenn die submitter.Property nicht existiert.
    //Update Ende 2024: IE ist Geschichte und Safari hat das auch 2022 "gelernt", eigentlich kann man laut canIUse.com die Property nun überall einsetzen.
    //Trotzdem behalte ich diesen Fallback erstmal bei, er ist ja nicht groß.
    const doesNotSupportSubmitEventWithSubmitterProp = typeof SubmitEvent === "undefined" || typeof Object.getOwnPropertyDescriptor(SubmitEvent.prototype, "submitter") === "undefined";
        
    document.querySelectorAll("form[action*='/HeftEinsendung/']").forEach(form => {
        if (doesNotSupportSubmitEventWithSubmitterProp) {
            form.querySelectorAll("button[type='submit'][name^='ABSENDEN'], button[type='submit'][name^='OEFFNEN']").forEach(btn => {
                btn.addEventListener("click", function() {
                    //Leider kann man nicht das "dataset" nehmen, weil das alle Values in Strings konvertiert. Also eine normale JS-Property auf dem form-Object,
                    //aber mit einem Namen, der wohl kaum browserintern schon benutzt werden dürfte:
                    form.deFeuOuesLastSubmitBtn = this;
                });
            });
        }
        form.addEventListener("submit", async event => {
            let btn = event.submitter;
            if (!btn) //Wenn event.submitter vom Brwoser z.B. nicht unterstützt wird (Safari, IE, s.o.)
                btn = form.deFeuOuesLastSubmitBtn;
            const isOpenBtn = btn && btn.name.startsWith("OEFFNEN");
            const heftOeffnenOption = btn ? btn.dataset.heftOeffnen : "NONE";
            
            if (!form.dataset.confirmed || form.dataset.confirmed !== "true") {
                event.preventDefault();
                
                //Erwarte globalen Confirmation-Text als Data am Form. Optional: Wenn er fehlt, nimm Default-Text.
                let confirmation = isOpenBtn ? form.dataset.hoConfirmation : form.dataset.hsConfirmation;
                let heading = "Sind Sie sicher?";
                
                if (!isOpenBtn) {
                    if (heftOeffnenOption === "EINSENDUNGEN_BEHALTEN") {
                        heading = "Abschließen und auswerten?";
                        if (!confirmation) 
                            confirmation = "Hiermit schließen Sie das Aufgabenheft und fordern eine Auswertung an. Danach sind zunächst keine "
                                + "weiteren Einsendungen zu Aufgaben dieses Hefts mehr möglich. Sie können jedoch noch bis zum Bearbeitungsende das Heft "
                                + "nachträglich wieder öffnen und die Einsendungen dann wieder nachbearbeiten.";
                    } else if (heftOeffnenOption === "EINSENDUNGEN_LOESCHEN") {
                        heading = "Abschließen und auswerten?";
                        if (!confirmation)
                            confirmation = "Hiermit schließen Sie das Aufgabenheft und fordern eine Auswertung an. Danach sind keine "
                                + "Nachkorrekturen oder Ergänzungungen Ihrer vorliegenden Antworten zu den Aufgaben dieses Hefts mehr möglich! "
                                + "(Lediglich ein komplettes Zurücksetzen des Hefts ist vor Bearbeitungsende dann noch möglich.)";
                    } else {
                        heading = "Endgültig abgeben?";
                        if (!confirmation)
                            confirmation = "Hiermit geben Sie Ihre Einsendungen zu den Aufgaben dieses Heftes endgültig ab. "
                                + "Danach können Sie keine weiteren Einsendungen zu diesem Heft mehr vornehmen!";
                    }
                } else if (heftOeffnenOption === "EINSENDUNGEN_LOESCHEN") {
                    heading = "Neu beginnen?";
                    if (!confirmation)
                        confirmation = "Hiermit setzen Sie das Aufgabenheft vollständig zurück, um es erneut bearbeiten zu können. "
                            + "Dazu werden alle Ihre Einsendungen samt vorliegender Auswertungen zu diesem Aufgabenheft gelöscht! "
                            + "Das Heft ist danach wieder zur erneuten Bearbeitung geöffnet und alle Aufgaben werden wieder im unbearbeiteten Zustand "
                            + "sein. (Im Falle randomisierter Aufgaben ist es möglich, dass Ihnen beim erneuten Bearbeiten des Hefts nicht wieder "
                            + "exakt dieselben Fragen gestellt werden.)";
                }   //Es gibt hier noch einen Else-Fall, in dem alles auf Defaultwerten bleibt: Heft-Öffnen-Button gedrückt und Einstellung != EINSENDUNGEN_LOESCHEN.
                    //In dem Fall wird höchstens dann eine Confirmation verlangt, falls ein Confirmation-String im Data-Attribut data-ho-confirmation stehen sollte.
                    //(Und nur in dem Fall greift die Default-Heading oben.)
                
                let confirmation2;
                //Optional kann am jeweiligen Submitbutton ein weiterer Text hängen, der dem ersten Text angehängt werden soll:
                if (btn) 
                    confirmation2 = btn.dataset.hsConfirmation; //kann wiederum den Wert auf "undefined" setzen, wenn der Submit-Button nämlich keine solche data-property hat.
                
                let ok = true;
                if (typeof confirmation === "string") {
                    if (typeof confirmation2 !== "string")
                        confirmation2 = "Sind Sie sicher?";
                    ok = await confirmationBoxDialog(heading, "<p>" + confirmation + "</p><p>" + confirmation2 + "</p>", "Nein, abbrechen!", "Ja", 
                            confirmation + "\n" + confirmation2);
                }
                //ok ist false, genau dann wenn eine ConfirmationBox überhaupt gezeigt und dann abgebrochen wurde.
                
                if (ok) {
                    form.dataset.confirmed = "true";
                    //insb. im Fall, dass kein Async Await statt gefunden hat, sondern wir uns noch im Eventhandler des ersten Submits befinden,
                    //in dem der Submit per preventDefault abgebrochen wurde, dann funktioniert ein sofortiges Neu-Submitten im selben Eventhandler nicht mehr!
                    //Daher Neusubmit der Einfachheit halber immer (auch in den Fällen, wo's nicht unbedingt nötig wäre) per Timeout "in ein neues Event
                    //verschieben":
                    window.setTimeout(function() {
                        if (form.requestSubmit)
                            form.requestSubmit(btn);
                        else
                            btn.click();
                    }, 0);
                }
            } else {
                let cleanHeftKey;
                if (btn) 
                    cleanHeftKey = btn.dataset.cleanHeftKey;
                if (typeof cleanHeftKey === "string" && typeof fieldInputBackup === "object")
                    fieldInputBackup.clean(cleanHeftKey);
                form.dataset.confirmed = "false";
                //Das sollte normalerweise keine Rolle spielen, wenn nach dem Setzen von confirmed=true sofort ein Submit ausgelöst wird.
                //Aber für den Fall, dass dieser anschließende Submit aus irgendeinem Grund doch nicht ausgeführt, z.B. von einem anderen Eventhandler
                //underdrückt werden sollte, dann soll hier confirmed wieder auf false zurückfallen.
            }
        });
    });
}